import { ButtonDemo } from "./ButtonDemo";
import { CheckBoxDemo } from "./CheckBoxDemo";
import { RadioDemo } from "./RadioDemo";
import { SpinnerDemo } from "./SpinnerDemo";
import { SwatchDemo } from "./SwatchDemo";
import { TextFieldDemo } from "./TextFieldDemo";

export function BasicControls() {
	return (
		<section id="basic-controls" className="demo-category">
			<h1>Basic Controls</h1>
			<ButtonDemo />
			<CheckBoxDemo />
			<RadioDemo />
			<TextFieldDemo />
			<SpinnerDemo />
			<SwatchDemo />
		</section>
	);
}
